module.exports = function getResource(label, vars = []) {
    const resources = { title: 'Recently Viewed' };

    return resources[label];
};
